import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=619b8b0f&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619b8b0f')) {
      api.createRecord('619b8b0f', component.options)
    } else {
      api.reload('619b8b0f', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=619b8b0f&", function () {
      api.rerender('619b8b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Badge.vue"
export default component.exports